import { create } from 'zustand';

type SimulationLocalCameraState = {
  stream: MediaStream | null;
  starting: boolean;
  denied: boolean;
  start: () => Promise<void>;
  stop: () => void;
};

function stopTracks(stream: MediaStream | null) {
  if (!stream) {
    return;
  }
  for (const track of stream.getTracks()) {
    track.stop();
  }
}

/**
 * Shared operator webcam for Control simulation Broadcast room-cam placeholders.
 * Survives show-mode / tab remounts so On air and Next can share the same preview.
 */
export const useSimulationLocalCameraStore = create<SimulationLocalCameraState>((set, get) => ({
  stream: null,
  starting: false,
  denied: false,
  start: async () => {
    if (get().starting) {
      return;
    }
    if (!navigator.mediaDevices?.getUserMedia) {
      set({ denied: true, stream: null });
      return;
    }
    set({ starting: true, denied: false });
    try {
      const next = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user' },
        audio: false,
      });
      stopTracks(get().stream);
      set({ stream: next, starting: false, denied: false });
    } catch {
      stopTracks(get().stream);
      set({ stream: null, starting: false, denied: true });
    }
  },
  stop: () => {
    stopTracks(get().stream);
    set({ stream: null, starting: false, denied: false });
  },
}));
